// smooth scroll effect


document.addEventListener('DOMContentLoaded', function () {
  // Disable custom smooth scroll for users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Desktop only
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;

  if (isDesktop) {
    let currentScroll = window.scrollY;
    let targetScroll = window.scrollY;
    let isScrolling = false;

    // ==========================
    // SETTINGS
    // ==========================

    // Wheel movement strength
    // Higher = scroll more distance
    const scrollSpeed = 1;

    // Smoothness
    // Lower = slower / smoother
    // 0.06 = very smooth
    // 0.10 = balanced
    // 0.15 = faster
    const smoothness = 0.09;

    // Maximum scroll movement per wheel event
    const maxDelta = 150;

    function getMaxScroll() {
      return Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
    }

    function smoothScroll() {
      const distance = targetScroll - currentScroll;

      currentScroll += distance * smoothness;

      if (Math.abs(distance) < 0.5) {
        currentScroll = targetScroll;
      }

      window.scrollTo(0, currentScroll);

      if (Math.abs(targetScroll - currentScroll) > 0.5) {
        requestAnimationFrame(smoothScroll);
      } else {
        isScrolling = false;
      }
    }

    function startAnimation() {
      if (!isScrolling) {
        isScrolling = true;
        requestAnimationFrame(smoothScroll);
      }
    }

    window.addEventListener(
      'wheel',
      function (event) {
        // Don't interfere with elements that have their own scrolling
        const scrollable = event.target.closest(
          '.shopify-section select, textarea, .drawer, .modal, [data-scrollable]'
        );

        if (scrollable) return;

        event.preventDefault();

        let delta = event.deltaY;

        // Prevent huge jumps from some mouse wheels
        delta = Math.max(-maxDelta, Math.min(maxDelta, delta));

        targetScroll += delta * scrollSpeed;

        targetScroll = Math.max(
          0,
          Math.min(targetScroll, getMaxScroll())
        );

        startAnimation();
      },
      { passive: false }
    );

    // Keep variables synced when scrollbar / keyboard / browser changes scroll
    window.addEventListener(
      'scroll',
      function () {
        if (!isScrolling) {
          currentScroll = window.scrollY;
          targetScroll = window.scrollY;
        }
      },
      { passive: true }
    );

    // Sync after resize
    window.addEventListener('resize', function () {
      currentScroll = window.scrollY;
      targetScroll = window.scrollY;
    });
  }

  // ==========================
  // SMOOTH ANCHOR LINKS
  // ==========================
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href^="#"]');

    if (!link) return;

    const href = link.getAttribute('href');

    if (!href || href === '#') return;

    const target = document.querySelector(href);

    if (!target) return;

    event.preventDefault();

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    history.pushState(null, '', href);
  });
});


// Header sticky scroll
document.addEventListener('DOMContentLoaded', function () {

  if (!document.body.classList.contains('template-index')) return;

  function updateHomeHeader() {

    if (window.scrollY > 15) {
      document.body.classList.add('header-scrolled-15');
    } else {
      document.body.classList.remove('header-scrolled-15');
    }

  }

  /* Run immediately */
  updateHomeHeader();

  /* Run while scrolling */
  window.addEventListener('scroll', updateHomeHeader, {
    passive: true
  });

});






